// @flow
import { INSTAGRAM_GRID } from 'Client/cms/toolkit/constants';
import { ProductInstagramLine } from 'Components/lines/product-instagram-line/ProductInstagramLine.jsx';
import { productInstagramResolver } from './productInstagram.resolver';

export const productInstagramDescriptor = {
  name: INSTAGRAM_GRID,
  component: ProductInstagramLine,
  resolve: productInstagramResolver.resolve,
};
